import { useCallback } from 'react';

import { PregnancyCompletionDateBasis } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

const PREDICTED_COMPLETION_DATE_BASIS_FIELD_NAME = 'predictedCompletionDateBasis';

type GynecologicalInterviewPredictedCompletionDateBasisFormBeanPart = {
   [PREDICTED_COMPLETION_DATE_BASIS_FIELD_NAME]: PregnancyCompletionDateBasis | null;
};

type GynecologicalInterviewPredictedCompletionDateBasisSelectProps = {
   readonly register: BindingCreator<
      GynecologicalInterviewPredictedCompletionDateBasisFormBeanPart,
      'predictedCompletionDateBasis'
   >;
};

const predictedCompletionDateBasisItems: PregnancyCompletionDateBasis[] = [
   'EXAMINATION',
   'LAST_MENSTRUATION',
   'LAST_OVULATION',
];

const useTriggerLabelExtractor = (): ((value: PregnancyCompletionDateBasis) => string) => {
   const translate = useTranslate();
   return useCallback(
      (value) => {
         return translate(gynecologicalInterviewTranslationKeys.predictedCompletionDateBasis[value]);
      },
      [translate]
   );
};

export const GynecologicalInterviewPredictedCompletionDateBasisSelect = (
   props: GynecologicalInterviewPredictedCompletionDateBasisSelectProps
): JSX.Element => {
   return (
      <Select<PregnancyCompletionDateBasis>
         testId={'predictedCompletionDateBasis'}
         controller={props.register(PREDICTED_COMPLETION_DATE_BASIS_FIELD_NAME, { required: true })}
         triggerLabelExtractor={useTriggerLabelExtractor()}
         label={gynecologicalInterviewTranslationKeys.determinedOnBasis}
         placeholder={gynecologicalInterviewTranslationKeys.choose}
      >
         <Select.List<PregnancyCompletionDateBasis> items={predictedCompletionDateBasisItems}>
            {(item: PregnancyCompletionDateBasis) => (
               <Select.Item
                  item={item}
                  testId={item}
                  label={gynecologicalInterviewTranslationKeys.predictedCompletionDateBasis[item]}
               />
            )}
         </Select.List>
      </Select>
   );
};
